import React from "react";
import styles from "./ColoredHeader.module.scss";

const ColoredHeader = ({ title, headerColor }) => {
    return (
        <div
            style={{ backgroundColor: headerColor }}
            className={styles.coloredHeader}>
            {title}
        </div>
    );
};

export default ColoredHeader;